import { Modal } from "@covertree/ui";
import { InfoDisclaimerBox } from "@covertree/ui/content";
import {
  AdditionalInterestFormBody,
  useAdditionalInterestForm,
} from "@covertree/features";

import type { AdditionalInterestFormModalProps } from "../types";
import { MODAL_TITLE } from "../consts";

export function AdditionalInterestFormModal({
  open,
  onClose,
  onSubmit,
  mode,
  isSubmitting = false,
  isTenantPolicy = false,
  selectedInterest,
  interestsCountByType,
}: AdditionalInterestFormModalProps) {
  const interestForm = useAdditionalInterestForm({
    mode,
    onSubmit,
    onClose,
    interestsCountByType,
    selectedInterest,
    isTenantPolicy,
    isSubmitting,
    isOpen: open,
  });

  return (
    <Modal
      open={open}
      onClose={interestForm.onCancel}
      disableClose={isSubmitting}
      title={MODAL_TITLE[mode]}
      maxWidth="md"
      sx={{
        overflow: "visible",
        "&:focus": {
          outline: "none",
        },
      }}>
      {mode !== "replace" && (
        <InfoDisclaimerBox mb={2} spacing={1.5}>
          Add interested parties here only if they need policy notifications and
          aren&apos;t paying the premium. If a mortgage company is paying, use
          the &quot;Replace Billing&quot; action instead.
        </InfoDisclaimerBox>
      )}
      <AdditionalInterestFormBody
        {...interestForm}
        submitLabel={mode === "add" ? "Add" : "Update"}
        fontSize={20}
      />
    </Modal>
  );
}
